var _classCallCheck = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _debug = require('debug');

var Bottleneck = require('bottleneck');

var Queue = require('./queue');

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var debug = _debug('winston-aws-cloudwatch:Relay');

var DEFAULT_OPTIONS = {
  submissionInterval: 2000,
  batchSize: 20
};

var Relay =
/*#__PURE__*/
function (_EventEmitter) {
  "use strict";

  _inherits(Relay, _EventEmitter);

  function Relay(client, options) {
    var _this;

    _classCallCheck(this, Relay);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Relay).call(this));
    debug('constructor', {
      client: client,
      options: options
    });
    _this._client = client;
    _this._options = Object.assign({}, DEFAULT_OPTIONS, options);
    _this._limiter = null;
    _this._queue = null;
    return _this;
  }

  _createClass(Relay, [{
    key: "start",
    value: function start() {
      debug('start');

      if (this._queue) {
        throw new Error('Already started');
      }

      this._limiter = new Bottleneck(1, this._options.submissionInterval, 1);
      this._queue = new Queue(); // Initial call to postpone first submission

      this._limiter.schedule(function () {
        return Promise.resolve();
      });
    }
  }, {
    key: "submit",
    value: function submit(item) {
      this._queue.push(item);

      this._scheduleSubmission();
    }
  }, {
    key: "_scheduleSubmission",
    value: function _scheduleSubmission() {
      var _this2 = this;

      debug('scheduleSubmission');

      this._limiter.schedule(function () {
        return _this2._submit();
      });
    }
  }, {
    key: "_submit",
    value: function _submit() {
      var _this3 = this;

      if (this._queue.size === 0) {
        debug('submit: queue empty');
        return Promise.resolve();
      }

      var batch = this._queue.head(this._options.batchSize);

      debug("submit: submitting ".concat(batch.length, " item(s)"));
      return this._client.submit(batch).then(function () {
        return _this3._onSubmitted(batch);
      }, function (err) {
        return _this3._onError(err, batch);
      }).then(function () {
        return _this3._scheduleSubmission();
      });
    }
  }, {
    key: "_onSubmitted",
    value: function _onSubmitted(batch) {
      debug('onSubmitted', {
        batch: batch
      });

      this._queue.remove(batch.length);

      for (var i = 0; i < batch.length; ++i) {
        var item = batch[i];
        item.callback(null, true);
      }
    }
  }, {
    key: "_onError",
    value: function _onError(err, batch) {
      debug('onError', {
        error: err
      });

      if (err.code === 'DataAlreadyAcceptedException') {
        // Assume the request got replayed and remove the batch
        this._queue.remove(batch.length);
      } else if (err.code === 'InvalidSequenceTokenException') {// Keep retrying
      } else {
        this.emit('error', err);
      }
    }
  }]);

  return Relay;
}(EventEmitter);

module.exports = Relay;